import { Box, styled } from '@mui/material';

export const SearchResultsFilterWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '0 20px 20px 20px',
  flexWrap: 'wrap'
});

export const SearchResultsCounterWrapper = styled(Box)(
  ({ isPhone, isSingleLocation }: { isPhone?: boolean; isSingleLocation?: boolean }) => ({
    fontSize: '14px',
    color: 'black',
    margin: isSingleLocation ? '0 0 0 auto' : isPhone ? '0 auto' : '0 0 0 auto',
    height: '32px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',

    whiteSpace: 'nowrap'
  })
);
